import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, ArrowRight } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-12 md:py-24 bg-zinc-900 px-4 relative overflow-hidden" data-id="element-27" data-mp="3ue88tie6v0rw">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom,_var(--tw-gradient-stops))] from-amber-900/20 via-zinc-900 to-zinc-900" data-id="element-28" data-mp="c7k4huqyqhna" />
      
      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-29" data-mp="m4ow4a3kv5bh">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-amber-500/10 border border-amber-500/20 text-amber-400 text-sm font-bold mb-6 md:mb-8 animate-pulse" data-id="element-30" data-mp="m2vjme6a9qvk">
          <AlertTriangle className="w-4 h-4" data-id="element-31" data-mp="14v6hftm2yymt" />
          PRECIO DE LANZAMIENTO $11.99 — SUBE A $47 AL LLEGAR AL LÍMITE
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-4xl md:text-6xl font-bold text-white mb-8 md:mb-12" data-id="element-32" data-mp="zxy01v8raymm">
          Tienes Dos Opciones. Una Cuesta $11.99. La Otra Te Va a Costar Miles.
        </motion.h2>

        <div className="grid md:grid-cols-2 gap-4 md:gap-6 mb-8 md:mb-12 text-left" data-id="element-33" data-mp="2m572ich83py5">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="p-6 md:p-8 rounded-2xl bg-zinc-950 border border-zinc-800 opacity-75" data-id="element-34" data-mp="2r38hal7m933t">
            <h3 className="text-xl font-bold text-zinc-300 mb-4" data-id="element-35" data-mp="34t2blj1w4fkx">Opción 1:</h3>
            <p className="text-zinc-500" data-id="element-36" data-mp="39s5byq6xdxmk">Cierras esta página. Sigues pagando de más. Sigues esperando diseños mediocres. Y dentro de 6 meses estás exactamente donde estás hoy — viendo cómo otros escalan con anuncios que tú podrías estar haciendo.</p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="p-6 md:p-8 rounded-2xl bg-gradient-to-br from-amber-500/10 to-zinc-950 border border-amber-500/30" data-id="element-37" data-mp="3iqqsygwr14l8">
            <h3 className="text-xl font-bold text-amber-500 mb-4" data-id="element-38" data-mp="1shyga795szap">Opción 2:</h3>
            <p className="text-zinc-300" data-id="element-39" data-mp="1nodnquqc4xiw">Inviertes menos que un almuerzo. En 15 minutos tienes tu primer anuncio cinematográfico. Y nunca vuelves a depender de nadie para tu publicidad.</p>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-40" data-mp="1xhugrwine8li">
          <p className="text-xl text-white mb-8 font-medium" data-id="element-41" data-mp="27ez6u7fm6o7l">
            La pregunta no es si puedes permitirte $11.99. Es si puedes permitirte seguir perdiendo dinero por no tenerlo.
          </p>

          <a href="#pricing" className="group relative inline-flex items-center justify-center gap-3 px-8 py-5 bg-amber-500 text-zinc-950 font-bold rounded-xl overflow-hidden transition-transform hover:scale-105 active:scale-95 w-full sm:w-auto text-lg" data-id="element-42" data-mp="d0y9jqzpq99m">
            <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform" data-id="element-43" data-mp="6ze96fgh885j" />
            <span data-id="element-44" data-mp="3ua40nfa04l3d">SÍ, QUIERO DEJAR DE PAGAR DE MÁS — $11.99</span>
            <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-45" data-mp="3u8atzzze20vd" />
          </a>
          
          <p className="text-zinc-500 text-sm mt-4" data-id="element-46" data-mp="3kcg36hl0gzhi">
            Acceso inmediato · Garantía de 7 días · Pago único de por vida
          </p>
        </motion.div>
      </div>
    </section>;
}